import React, { useState } from "react";
import mobile from "../../assets/mobile.png";
import "./GetAppScreen.css";
// import googleplay from "../../assets/googleplay.png";
import appstore from "../../assets/appstore.svg";
import googleplay from "../../assets/googleplay.svg";
import { postShareAppLink } from "../../utils/api";
import { notify } from "react-notify-toast";

function GetAppScreen() {
  const [userEmail, setUserEmail] = useState("");
  const shareApp = async () => {
    if (userEmail.trim() !== "") {
      try {
        await postShareAppLink(userEmail);
        notify.show("App shared to your email.", "success", 3000);
      } catch (error) {
        console.log(error, "erroor");
        notify.show("Please enter a valid email address.", "error", 3000);
      }
    } else {
      notify.show("Please enter a valid email address.", "error", 3000);
    }
  };
  return (
    <div className="geta-app-container">
      <div className="get-app-image">
        <img style={{ height: "44em" }} src={mobile} alt="" />
      </div>
      <div className="get-app-wrapper">
        <div className="get-app-title">
          <div className="get-app-heading">GET THE KIVLIK APP</div>
          <div className="get-app-para">
            We will send you a link, open it on your email to download the app
          </div>
        </div>
        <div className="get-app-email">
          <div>
            <input
              className="get-app-input"
              type="text"
              placeholder="Email"
              onChange={(e) => setUserEmail(e.target.value)}
              value={userEmail}
            />
          </div>
          <div className="get-app-padding">
            <button className="get-email-button" onClick={shareApp}>
              Share App Link
            </button>
          </div>
        </div>
        <div className="get-app-button">
          <div className="get-head-padding">Download app from</div>
          <div className="get-app-buttoncontainer">
            <div className="button-wrapper-pad">
              <a
                href="https://play.google.com/store/search?q=kivlik&c=apps&hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="button-wrapper" src={googleplay} alt="" />
              </a>
            </div>
            <div className="button-wrapper-pad">
              <img className="button-wrapper" src={appstore} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetAppScreen;
